import { Badge } from '../../r2/Badge';
import { Text } from '../../r2/Text';
import { CodeBlock } from '../../r2/CodeBlock';
import styles from './AssemblyStep.module.css';

const LAYER_VARIANT: Record<string, 'default' | 'success' | 'warning' | 'danger'> = {
  r1: 'danger',
  r2: 'warning',
  r3: 'default',
  r4: 'success',
  r5: 'default',
};

export interface AssemblyStepProps {
  layer: string;
  action: string;
  code?: string;
  index: number;
}

export function AssemblyStep({ layer, action, code, index }: AssemblyStepProps) {
  return (
    <div
      data-crd-id="r3.bq-assembly-step"
      data-crd-layer="r3"
      className={styles.step}
      style={{ animationDelay: `${index * 100}ms` }}
    >
      <div className={styles.header}>
        <span className={styles.index}>{index + 1}</span>
        <Badge variant={LAYER_VARIANT[layer] ?? 'default'}>
          {layer.toUpperCase()}
        </Badge>
        <Text size="r3" as="span" className={styles.action}>
          {action}
        </Text>
      </div>
      {code && <CodeBlock>{code}</CodeBlock>}
    </div>
  );
}
